module.exports = "<main>\n    <transfers-table></transfers-table>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/home.html
// module id = 185
// module chunks = 0